var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('range-input-with-unit',_vm._b({model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}},'range-input-with-unit',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }